import { Tag } from "bbcode-to-react";
import * as React from "react";
class YoutubeTag extends Tag {
    toHTML() {
        return [
            `<iframe src="https://www.youtube-nocookie.com/embed/${this.getContent()}" referrerpolicy="strict-origin-when-cross-origin" allow="encrypted-media; web-share" title="YouTube video player"/>`,
        ];
    }
    toReact() {
        return (React.createElement("div", { className: "youtube-embed-container" },
            React.createElement("iframe", { src: `https://www.youtube-nocookie.com/embed/${this.getContent()}`, referrerPolicy: "strict-origin-when-cross-origin", allow: "encrypted-media; web-share", title: "YouTube video player" }),
            React.createElement("p", { className: "youtube-privacy-notice" }, "Playing this video will store cookies on your device")));
    }
}
export default YoutubeTag;
